
$(document).ready(function () {
    $('.featureLineupContainer').each((i, element) => {
        const title = $(element).find('.featureLineup-title');
        let titleText = title.text().trim();
        if (titleText.length > 45) {
            title.text(`${titleText.substring(0, 45)}...`);
            title.attr('title', titleText);
            titleText = `${titleText.substring(0, 45)}...`;
        } else {
            title.text(titleText);
        }
        $(element).find('.featureLineup-buynow a.button').addClass('buyNowButton');
        $(element)
            .find('.featureLineup-more .button, .featureLineup-headline')
            .addClass('buttonSmall');
        const description = $(element).find('.featureLineup-text').eq(1);
        const descriptionText = description.text();
        description.empty();
        description.html(
            `<div class="featureLineup-description">
            <h4>${titleText}</h4>
            <span>${descriptionText}</span>
            </div>`

        );
    });
})